import { BrandEntranceComponent } from '@features/spots/brand-entrance/brand-entrance.component';
import { BrandHeroComponent } from '@features/spots/brand-hero/brand-hero.component';
import { BrandSpotAlternateComponent } from '@features/spots/brand-spot-alternate/brand-spot-alternate.component';
import { CategoryEntranceComponent } from '@features/spots/category-entrance/category-entrance.component';
import { ChildrenLinksComponent } from '@features/spots/children-links/children-links.component';
import { GiftcardBalanceComponent } from '@features/spots/giftcard-balance/giftcard-balance.component';
import { HeroSpotComponent } from '@features/spots/hero-spot/hero-spot.component';
import { ImageEntryComponent } from '@features/spots/image-entry/image-entry.component';
import { InspirationSliderComponent } from '@features/spots/inspiration-slider/inspiration-slider.component';
import { InspirationThreeImagesComponent } from '@features/spots/inspiration-three-images/inspiration-three-images.component';
import { InspirationTouchpointsEntrancesComponent } from '@features/spots/inspiration-touchpoints-entrances/inspiration-touchpoints-entrances.component';
import { NewsletterComponent } from '@features/spots/newsletter/newsletter.component';
import { RecipeSpotComponent } from '@features/spots/recipe/recipe-spot/recipe-spot.component';
import { RichTextEmphasisComponent } from '@features/spots/rich-text-emphasis/rich-text-emphasis.component';
import { RichTextEndlessColumnsComponent } from '@features/spots/rich-text-endless-columns/rich-text-endless-columns.component';
import { RichTextTwoColumnComponent } from '@features/spots/rich-text-two-column/rich-text-two-column.component';
import { SignUpSignInComponent } from '@features/spots/sign-up-sign-in/sign-up-sign-in.component';
import { LastSeenSliderComponent } from '@features/spots/sliders/last-seen-slider.component';
import { MostPopularInBrandSliderComponent } from '@features/spots/sliders/most-popular-in-brand-slider.component';
import { MostPopularInCategorySliderComponent } from '@features/spots/sliders/most-popular-in-category-slider.component';
import { MostPopularProductsSliderComponent } from '@features/spots/sliders/most-popular-products-slider.component';
import { ProductIdSliderComponent } from '@features/spots/sliders/product-id-slider.component';
import { VideoSpotComponent } from '@features/spots/video-spot/video-spot.component';
import { HeroSameDaySpotComponent } from '@features/spots/hero-same-day-spot/hero-same-day-spot.component';
import { ThirdPartyScriptComponent } from '@features/spots/third-party-script/third-party-script.component';
import { TopSpotComponent } from '@features/spots/top-spot/top-spot.component';
import { ProductListSpotComponent } from '@features/spots/product-list-spot/product-list-spot.component';

export const blockListSpotComponents = [
    RichTextTwoColumnComponent,
    HeroSpotComponent,
    HeroSameDaySpotComponent,
    CategoryEntranceComponent,
    RichTextEmphasisComponent,
    InspirationThreeImagesComponent,
    BrandEntranceComponent,
    BrandHeroComponent,
    InspirationTouchpointsEntrancesComponent,
    InspirationSliderComponent,
    VideoSpotComponent,
    ImageEntryComponent,
    NewsletterComponent,
    RecipeSpotComponent,
    LastSeenSliderComponent,
    MostPopularInBrandSliderComponent,
    MostPopularInCategorySliderComponent,
    MostPopularProductsSliderComponent,
    ProductIdSliderComponent,
    ChildrenLinksComponent,
    GiftcardBalanceComponent,
    BrandSpotAlternateComponent,
    RichTextEndlessColumnsComponent,
    SignUpSignInComponent,
    ThirdPartyScriptComponent,
    ProductListSpotComponent,
    TopSpotComponent
];
